import { RichText as BaseRichText } from "prismic-reactjs";
import linkResolver from "./linkResolver";

export const RichText = (richText) =>
  BaseRichText.render(richText, linkResolver);
